export default __webpack_public_path__ + "static/media/ttg-grey.0ec4289a.svg";